// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1GcsS","list":"BalanceDue_list__1DncK","listRow":"BalanceDue_listRow__1pm7o","total":"BalanceDue_total__1KvVn"};